module.exports = __webpack_public_path__ + "static/media/london-25.ccd9b496.jpg";